<template>
  <b-tab title="Latest Info" v-if="this.detail.latestInfos && this.detail.latestInfos[0]">
    <b-card-text>
     <b>Latest information:<br>  {{this.detail.latestInfos[0].lastChangeDate | moment("DD MMM YYYY")}}: </b>
     <span  v-html="this.detail.latestInfos[0].content"></span>
    </b-card-text>

    <hr>
    <div v-if="this.detail.additionalInfo">
      <b>Additional information: </b>
      <span v-html="this.detail.additionalInfo"></span>
    </div>
    <div v-if="this.detail.staticAdditionalInfo">
      <b>Additional information: </b>
          <span  v-html="this.detail.staticAdditionalInfo"></span>
    </div>

  </b-tab>

</template>

<script>

export default {
  name: 'CallDetail',
  props: ['json'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    detail () {
      return JSON.parse(this.json);
    }
  }
}
</script>

<style>

</style>
